export const DEFAULT_COHORT_CASH_FLOW_FOOTNOTE =
  'Cohort cash flow could reflect Company cohorts on a gross profit basis rather than net revenue';

export const DEFAULT_SECURITY_WORDING =
  'Perfected first-priority lien on the Company’s assets';

export const REPAYMENT_PROPORTIONAL_LINE =
  'Monthly repayment for each cohort equal to Treisar’s proportional share of cohort cash flow** (e.g. if Treisar funding is 80% of a given cohort cost, repayment will be 80% of that cohort ROAS), up to an amount equal to Treisar’s investment plus capped return.';

export const REPAYMENT_SETOFF_LINE =
  'Monthly repayments may be set-off against any subsequent growth investment';

export function buildRepaymentProportionalLine() {
  return REPAYMENT_PROPORTIONAL_LINE;
}

export function buildRepaymentSetoffLine() {
  return REPAYMENT_SETOFF_LINE;
}

export function buildRepaymentCohortFootnote(fields) {
  const text = String(fields.cohortCashFlowFootnote ?? '').trim();
  return text || DEFAULT_COHORT_CASH_FLOW_FOOTNOTE;
}

export function buildRepaymentCohortFootnoteDocx(fields) {
  return `[** ${buildRepaymentCohortFootnote(fields)}]`;
}

export function buildSecurityClause(fields) {
  const text = String(fields.securityWording ?? '').trim();
  return text || DEFAULT_SECURITY_WORDING;
}
